import { render, staticRenderFns } from "./TransactionDetailsView.vue?vue&type=template&id=4e142919"
import script from "./TransactionDetailsView.vue?vue&type=script&lang=js"
export * from "./TransactionDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports